import { Avatar, Stack, Typography } from '@mui/material';
import { shortDateFormat } from 'Config';
import {
  AppliesContext,
  IAplicationsFilters,
  initialFiltersData,
} from 'Context/AppliesContext';
import { format } from 'date-fns';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { WhiteExit } from 'Images';
import { useContext } from 'react';

export const SelectedFiltersDisplay = () => {
  const {
    filtersData,
    filteredApplications,
    setFiltersData,
    filterApplications,
    isFilterByYear,
  } = useContext(AppliesContext);
  const dictionary = useDictionary(Dictionary, DICTIONARY.Applies);
  const isDesktop = useIsDesktop();

  const getTextForFilterDataKey = (
    filtersDataKey: keyof IAplicationsFilters
  ): string => {
    if (
      filtersDataKey === 'includePhoneRequests' &&
      filtersData.includePhoneRequests
    ) {
      return dictionary.phoneApplicationFilter;
    }

    if (
      filtersDataKey === 'includeWebRequests' &&
      filtersData.includeWebRequests
    )
      return dictionary.onlineApplicationFilter;

    if (filtersData[filtersDataKey]) {
      if (filtersDataKey === 'from')
        return `${dictionary.from} - ${format(
          filtersData[filtersDataKey] as Date,
          shortDateFormat
        )}`;
      if (filtersDataKey === 'to')
        return `${dictionary.to} - ${format(
          filtersData[filtersDataKey] as Date,
          shortDateFormat
        )}`;
      return filtersData[filtersDataKey]?.toString() || '';
    }

    return '';
  };

  const hideSelectedFilter = (filterName: string) => {
    return (
      (isFilterByYear && filterName === 'from') ||
      (isFilterByYear && filterName === 'to') ||
      (!isFilterByYear && filterName === 'year')
    );
  };

  const onClickRemove = (filterName: string) => {
    const newFiltersData = {
      ...filtersData,
      [filterName]: initialFiltersData[filterName as keyof IAplicationsFilters],
    };

    if (
      filterName === 'includePhoneRequests' ||
      filterName === 'includeWebRequests'
    ) {
      newFiltersData.includePhoneRequests = true;
      newFiltersData.includeWebRequests = true;
    }
    setFiltersData(newFiltersData);
    filterApplications(newFiltersData);
  };

  return (
    <Stack width='100%' gap='16px' mb='12px' justifyContent='flex-start'>
      <Typography variant='body3'>
        {dictionary.found} {filteredApplications.length}{' '}
        {isDesktop ? dictionary.applies : dictionary.appliesForSelectedFilters}
      </Typography>
      <Stack direction='row' gap='16px' flexWrap='wrap'>
        {Object.keys(filtersData).map((filterName, index) => {
          const currentValue =
            filtersData[filterName as keyof IAplicationsFilters];

          if (
            (filterName === 'includePhoneRequests' &&
              currentValue &&
              filtersData.includeWebRequests) ||
            (filterName === 'includeWebRequests' &&
              currentValue &&
              filtersData.includePhoneRequests)
          )
            return null;

          return (
            ((filterName === 'includePhoneRequests' && currentValue) ||
              (filterName === 'includeWebRequests' && currentValue) ||
              currentValue) && (
              <Stack
                display={hideSelectedFilter(filterName) ? 'none' : undefined}
                key={filterName + index}
                direction='row'
                alignItems='center'
                gap='8px'
                sx={{
                  backgroundColor: 'purple2.main',
                  borderRadius: '6px',
                  p: '5px 11px',
                  width: 'fit-content',
                  cursor: 'pointer',
                  color: 'white',
                }}
                onClick={() => onClickRemove(filterName)}
              >
                <Avatar
                  alt=''
                  src={WhiteExit}
                  sx={{ width: '12px', height: '12px' }}
                />
                <Typography lineHeight='22px' variant='body6'>
                  {getTextForFilterDataKey(
                    filterName as keyof IAplicationsFilters
                  )}
                </Typography>
              </Stack>
            )
          );
        })}
      </Stack>
    </Stack>
  );
};
